import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrImageCategory.ts
var t = () => e("imageCategory");
//#endregion
export { t as useTrImageCategory };
